import React from 'react'

const Heading = (props) => {
  return (
    <div className="heading">
        <h3 className='text-center display-6 text-uppercase lead' data-aos="zoom-in">{props.headingTitle}</h3>
        <div className="heading-line mb-5"  data-aos="zoom-in"></div>
    </div>
  )
}

export default Heading